import wrapError from "@/components/helpers/wrapError"

export const apiSendGroupEmail = (params, success, error) => {
  const emailPayload = JSON.stringify({
    subject: params.subject,
    message: params.body,
    groupType: params.groupType,
    attachmentIds: params.attachmentIds,
    scope: params.scope,
    mergeDefaults: params.mergeDefaults ?? {},
    mailMergeQuery: params.mailMergeQuery,
  })

  $.ajax({
    type: "POST",
    url: "/api/groupEmailManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: emailPayload,
    success,
    error: wrapError(error, "sendGroupEmail"),
  })
}

export const getGroupEmailRecipients = (params, success, error) => {
  const { groupEmailType, mailMergeQuery, scope } = params
  const payload = {
    groupType: groupEmailType,
  }

  if (mailMergeQuery || mailMergeQuery === "") {
    payload.mailMergeQuery = mailMergeQuery
    payload.scope = scope
  }
  $.ajax({
    type: "GET",
    url: "/api/groupEmailManager",
    dataType: "JSON",
    data: payload,
    success,
    error: wrapError(error, "getGroupEmailRecipients"),
  })
}

export const apiFetchEmailSuggestions = (query, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/personAutocompleteManager?query=${encodeURIComponent(query)}`,
    success,
    error: wrapError(error, "apiFetchEmailSuggestions"),
  })
}
